<template>
    <div class="hszd-container">
        <LeftMenu />
        <a-config-provider :locale="locale"
        :theme="defaultTheme">
            <a-app class="hszd-main">
                <div class="content-wrapper">
                    <router-view v-slot="{ Component }">
                        <transition :name="transitionType" mode="out-in">
                            <keep-alive>
                                <component :is="Component" />
                            </keep-alive>
                        </transition>
                    </router-view>
                </div>
            </a-app>
        </a-config-provider>
    </div>
</template>
<script setup>
import LeftMenu from './LeftMenu.vue';
import { theme } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
const locale = zhCN
const defaultTheme = {
    token: {
        colorPrimary: "#246BF0",
        borderRadius: "8px",
        controlHeight: 40, // 控件高度
        fontSize: 14, // 字体大小
        colorTextHeading: '#1E293B',
        colorBorder: '#E2E8F0',
        // fontSizeIcon: 18,
    }
}
const token = theme.useToken().token.value
console.log(token)
Object.values(token).forEach(item => {
    if (item.includes)
    console.log(item.includes('0 2px 0 rgba(5, 138, 255, 0.06)'))

})

// 页面过渡效果类型
const transitionType = ref('fade');
const route = useRoute();

// 根据路由变化动态改变过渡效果
watch(() => route.path, (newPath) => {
    // 可以根据路由路径设置不同的过渡效果
    // 例如: dashboard使用滑动效果，meetings使用缩放效果等
    if (newPath.includes('/dashboard')) {
        transitionType.value = 'slide-left';
    } else if (newPath.includes('/meetings')) {
        transitionType.value = 'zoom';
    } else if (newPath.includes('/upload')) {
        transitionType.value = 'slide-up';
    } else if (newPath.includes('/deepseek')) {
        transitionType.value = 'flip';
    } else {
        transitionType.value = 'fade';
    }
}, { immediate: true });
</script>
<style>
.hszd-container {
    display: flex;
    height: 100%;
    background-color: #F8FAFC;
}
.hszd-main {
    flex: 1;
    width: 0;
    margin-left: var(--menu-width); /* 为固定定位的菜单留出空间 */
    transition: all 0.3s ease;
}
.content-wrapper {
    max-width: 1600px;
    margin: 0 auto;
    height: 100%;
    padding: 0;
    perspective: 1200px; /* 启用3D视角，增强3D效果 */
}

/* 基础淡入淡出效果 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* 向左滑动效果 */
.slide-left-enter-active,
.slide-left-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-left-enter-from {
    opacity: 0;
    transform: translateX(50px);
}
.slide-left-leave-to {
    opacity: 0;
    transform: translateX(-50px);
}

/* 向上滑动效果 */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-up-enter-from {
    opacity: 0;
    transform: translateY(50px);
}
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(-50px);
}

/* 缩放效果 */
.zoom-enter-active,
.zoom-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.zoom-enter-from {
    opacity: 0;
    transform: scale(0.95);
}
.zoom-leave-to {
    opacity: 0;
    transform: scale(1.05);
}

/* 3D翻转效果 */
.flip-enter-active,
.flip-leave-active {
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    transform-style: preserve-3d;
}
.flip-enter-from {
    opacity: 0;
    transform: rotateY(-90deg);
}
.flip-leave-to {
    opacity: 0;
    transform: rotateY(90deg);
}
</style>